import type { AmbitoId } from './ambitiStats'

export interface ComuneReferendum {
  nome: string
  voto: 'SI' | 'NO'
  percentuale: number
  ambitoId: AmbitoId
}

export const REFERENDUM_COMUNI: ComuneReferendum[] = [
  // Hanno votato NO
  { nome: 'Agrate Brianza',      voto: 'NO', percentuale: 50.37, ambitoId: 'vimercate' },
  { nome: 'Arcore',              voto: 'NO', percentuale: 50.25, ambitoId: 'vimercate' },
  { nome: 'Bellusco',            voto: 'NO', percentuale: 51.81, ambitoId: 'vimercate' },
  { nome: 'Burago di Molgora',   voto: 'NO', percentuale: 51.09, ambitoId: 'vimercate' },
  { nome: 'Carnate',             voto: 'NO', percentuale: 56.56, ambitoId: 'vimercate' },
  { nome: 'Cavenago di Brianza', voto: 'NO', percentuale: 55.48, ambitoId: 'vimercate' },
  { nome: 'Mezzago',             voto: 'NO', percentuale: 54.03, ambitoId: 'vimercate' },
  { nome: 'Monza',               voto: 'NO', percentuale: 52.00, ambitoId: 'monza'     },
  { nome: 'Ornago',              voto: 'NO', percentuale: 52.18, ambitoId: 'vimercate' },
  { nome: 'Ronco Briantino',     voto: 'NO', percentuale: 52.93, ambitoId: 'vimercate' },
  { nome: 'Usmate Velate',       voto: 'NO', percentuale: 50.70, ambitoId: 'vimercate' },
  { nome: 'Vimercate',           voto: 'NO', percentuale: 57.38, ambitoId: 'vimercate' },

  // Hanno votato SÌ
  { nome: 'Aicurzio',              voto: 'SI', percentuale: 50.74, ambitoId: 'vimercate' },
  { nome: 'Albiate',               voto: 'SI', percentuale: 55.70, ambitoId: 'carate'    },
  { nome: 'Barlassina',            voto: 'SI', percentuale: 58.51, ambitoId: 'seregno'   },
  { nome: 'Bernareggio',           voto: 'SI', percentuale: 51.84, ambitoId: 'vimercate' },
  { nome: 'Besana in Brianza',     voto: 'SI', percentuale: 54.31, ambitoId: 'carate'    },
  { nome: 'Biassono',              voto: 'SI', percentuale: 58.36, ambitoId: 'carate'    },
  { nome: 'Bovisio Masciago',      voto: 'SI', percentuale: 51.63, ambitoId: 'desio'     },
  { nome: 'Briosco',               voto: 'SI', percentuale: 62.71, ambitoId: 'carate'    },
  { nome: 'Brugherio',             voto: 'SI', percentuale: 50.86, ambitoId: 'monza'     },
  { nome: 'Busnago',               voto: 'SI', percentuale: 53.44, ambitoId: 'vimercate' },
  { nome: 'Camparada',             voto: 'SI', percentuale: 55.66, ambitoId: 'vimercate' },
  { nome: 'Caponago',              voto: 'SI', percentuale: 51.63, ambitoId: 'vimercate' },
  { nome: 'Carate Brianza',        voto: 'SI', percentuale: 57.43, ambitoId: 'carate'    },
  { nome: 'Ceriano Laghetto',      voto: 'SI', percentuale: 50.87, ambitoId: 'seregno'   },
  { nome: 'Cesano Maderno',        voto: 'SI', percentuale: 55.20, ambitoId: 'desio'     },
  { nome: 'Cogliate',              voto: 'SI', percentuale: 57.97, ambitoId: 'seregno'   },
  { nome: 'Concorezzo',            voto: 'SI', percentuale: 51.58, ambitoId: 'vimercate' },
  { nome: "Cornate d'Adda",        voto: 'SI', percentuale: 52.21, ambitoId: 'vimercate' },
  { nome: 'Correzzana',            voto: 'SI', percentuale: 61.50, ambitoId: 'vimercate' },
  { nome: 'Desio',                 voto: 'SI', percentuale: 53.03, ambitoId: 'desio'     },
  { nome: 'Giussano',              voto: 'SI', percentuale: 61.40, ambitoId: 'seregno'   },
  { nome: 'Lazzate',               voto: 'SI', percentuale: 60.51, ambitoId: 'seregno'   },
  { nome: 'Lentate sul Seveso',    voto: 'SI', percentuale: 57.43, ambitoId: 'seregno'   },
  { nome: 'Lesmo',                 voto: 'SI', percentuale: 56.80, ambitoId: 'vimercate' },
  { nome: 'Limbiate',              voto: 'SI', percentuale: 50.29, ambitoId: 'desio'     },
  { nome: 'Lissone',               voto: 'SI', percentuale: 54.03, ambitoId: 'carate'    },
  { nome: 'Macherio',              voto: 'SI', percentuale: 57.61, ambitoId: 'carate'    },
  { nome: 'Meda',                  voto: 'SI', percentuale: 58.36, ambitoId: 'seregno'   },
  { nome: 'Misinto',               voto: 'SI', percentuale: 56.34, ambitoId: 'seregno'   },
  { nome: 'Muggiò',                voto: 'SI', percentuale: 52.25, ambitoId: 'desio'     },
  { nome: 'Nova Milanese',         voto: 'SI', percentuale: 50.43, ambitoId: 'desio'     },
  { nome: 'Renate',                voto: 'SI', percentuale: 53.66, ambitoId: 'carate'    },
  { nome: 'Roncello',              voto: 'SI', percentuale: 53.07, ambitoId: 'vimercate' },
  { nome: 'Seregno',               voto: 'SI', percentuale: 57.10, ambitoId: 'seregno'   },
  { nome: 'Seveso',                voto: 'SI', percentuale: 57.10, ambitoId: 'seregno'   },
  { nome: 'Sovico',                voto: 'SI', percentuale: 56.89, ambitoId: 'carate'    },
  { nome: 'Sulbiate',              voto: 'SI', percentuale: 52.14, ambitoId: 'vimercate' },
  { nome: 'Triuggio',              voto: 'SI', percentuale: 59.04, ambitoId: 'carate'    },
  { nome: 'Varedo',                voto: 'SI', percentuale: 52.56, ambitoId: 'desio'     },
  { nome: 'Vedano al Lambro',      voto: 'SI', percentuale: 56.07, ambitoId: 'carate'    },
  { nome: 'Veduggio con Colzano',  voto: 'SI', percentuale: 56.47, ambitoId: 'carate'    },
  { nome: 'Verano Brianza',        voto: 'SI', percentuale: 58.10, ambitoId: 'carate'    },
  { nome: 'Villasanta',            voto: 'SI', percentuale: 50.01, ambitoId: 'monza'     },
]
